var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.97 8.76001C20.88 8.34001 20.6 8.05001 20.13 7.58001L16.43 3.88001C15.96 3.41001 15.67 3.12001 15.25 3.04001C14.87 2.96001 14.49 3.04001 14.18 3.25001C13.82 3.49001 13.66 3.86001 13.4 4.47001L12.63 6.26001L12.54 6.39001L11.42 7.51001C11.42 7.51001 11.34 7.59001 11.34 7.60001C11.31 7.60001 11.27 7.62001 11.2 7.63001L8.56002 8.16001C7.74002 8.32001 7.30002 8.41001 6.98002 8.77001C6.70002 9.09001 6.57002 9.50001 6.63002 9.92001C6.70002 10.4 7.02002 10.72 7.61002 11.31L9.51002 13.21L4.02002 18.7L3.02002 21L5.32002 20L10.81 14.51L12.71 16.41C13.3 17 13.62 17.32 14.1 17.39C14.17 17.39 14.23 17.4 14.3 17.4C14.65 17.4 14.99 17.27 15.25 17.04C15.61 16.72 15.7 16.27 15.86 15.45L16.39 12.81C16.4 12.75 16.41 12.71 16.41 12.69C16.43 12.66 16.46 12.64 16.51 12.59L17.64 11.46L19.56 10.61C20.17 10.35 20.54 10.19 20.78 9.83001C20.99 9.51001 21.06 9.13001 20.99 8.76001H20.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.9e6cc4ac071723b58be1f387c69bf2e3.svg";
export { ForwardRef as ReactComponent };